module.exports = __webpack_public_path__ + "img/kasvurahoitus@2x.9a79ba1.png";